<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Chapter-Title-Page-Break">Author’s Note</p>
<p class="Flush-left">Until the mid-1600s, the town of Perth, Scotland, was St. John’s Town of Perth, after its namesake. Perth was the entire region now known as Perthshire.</p>
<p class="ORIM-Body-Text">Medieval Highlanders rarely used surnames, because most people in a given area belonged to one clan. In this book, for example, Gaelic <em class="italic _idGenCharOverride-1">Mòr</em>, as in Glen Mòr and Shaw Mòr, means “the Great.” </p>
<p class="ORIM-Body-Text">Kilts were nonexistent until the sixteenth century. But dyes came from local plants, so woven wool garments in one area might have colors and/or patterns distinctive to that area. Clan tartans came along much later and became popular after Queen Victoria visited Scotland (1842) and acquired Balmoral (1852).</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-1-1.vue?04f5e6ea